import { ColumnConfig } from '@/shared/types/table';
import { SkeletonCell } from '../atoms';

interface SkeletonRowProps {
  columns: ColumnConfig[];
  showSelection?: boolean;
  showExpand?: boolean;
}

export const SkeletonRow = ({
  columns,
  showSelection = false,
  showExpand = false,
}: SkeletonRowProps) => {
  return (
    <tr>
      {showExpand && (
        <td className="ui-w-12 ui-border-b ui-border-default ui-bg-fill ui-px-4 ui-py-3" />
      )}

      {showSelection && (
        <td className="ui-w-12 ui-border-b ui-border-default ui-bg-fill ui-px-4 ui-py-3" />
      )}

      {columns.map((column) => (
        <SkeletonCell key={column.id} value={null} row={null} column={column} />
      ))}
    </tr>
  );
};
